  <div class="carousel-container">
    <div class="carousel" #carouselWrapper>
      @for (item of carouselItems; track $index; let i = $index) {
      <div class="carousel-card"
        [ngClass]="{ 'first-card': i === 0, 'last-card': i === carouselItems.length - 1, 'not-clickable': !isOpenable(item) }"
        [class.is-loaded]="isSettled(item)"
        (click)="goToProject(item)">
        <!-- Every photo still starts at once, but the cards on screen first get
             the bandwidth: all of them used to start at the same priority, so
             the visible few were sharing the connection with the rest.
             fetchpriority is bound before src so it is in place when the
             request goes out. error settles the card too, so a dead image does
             not shimmer forever. -->
        <img [attr.fetchpriority]="i < priorityCount ? 'high' : 'low'" [src]="item.imageUrl"
          class="img-fluid" decoding="async" (load)="markSettled(item)" (error)="markSettled(item)" />
        <div class="card-caption">
          <span class="pill">{{ item.location }}</span>
          <span class="title">{{ item.title }}</span>
          <span class="description">{{ item.description }}</span>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="carousel-arrows">
    <div class="custom-button" [class.disabled]="isAtStart" (click)="scrollLeft()"><i
        class="fa-light fa-angle-left"></i></div>
    <div class="custom-button" [class.disabled]="isAtEnd" (click)="scrollRight()"><i
        class="fa-light fa-angle-right"></i></div>
  </div>